import React from 'react';
import { FormikInput as Field } from 'Components/frameworks/formik/FormikInput';
import { t } from 'Src/i18n';
import { getKidFutureBithdateValidator } from './productQuotationForm.utils';
type ProductQuotationFormKidBirthdateProps = {
  dateFormat: string;
  index: number;
  kidsNumber: number;
  minAuthorizedAgeInMonths: number;
  maxAuthorizedAgeInMonths: number;
};
export const ProductQuotationFormKidBirthdate = ({
  dateFormat,
  index,
  kidsNumber,
  minAuthorizedAgeInMonths,
  maxAuthorizedAgeInMonths,
}: ProductQuotationFormKidBirthdateProps) => (
  <div className={`${kidsNumber > 1 ? 'w-1/2' : 'w-full'} p-10`}>
    <p className="mb-10 text-14 font-bold">
      {t('productQuotationForm.pax.kidLabel', {
        n: index + 1,
      })}
    </p>
    <Field
      dataTestId={`kids-${index}-birthdate-field`}
      hideErrorMessage
      name={`kids.${index}.birthdate`}
      type="birthdate"
      dayPlaceholder="DD"
      monthPlaceholder="MM"
      yearPlaceholder="YYYY"
      dateFormat={dateFormat}
      validate={getKidFutureBithdateValidator(minAuthorizedAgeInMonths, maxAuthorizedAgeInMonths)}
    />
  </div>
);
